import { render, staticRenderFns } from "./MaintenanceLogo.vue?vue&type=template&id=2b5a1179&"
import script from "./MaintenanceLogo.vue?vue&type=script&lang=js&"
export * from "./MaintenanceLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports